import { render, staticRenderFns } from "./register.vue?vue&type=template&id=4b4b92ab&scoped=true"
import script from "./register.vue?vue&type=script&lang=js"
export * from "./register.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/home/register.css?vue&type=style&index=0&id=4b4b92ab&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4b92ab",
  null
  
)

export default component.exports